'use client';
import React from 'react';

const clientLogos = [
{
  src: "/assets/images/image-1786011773354.png",
  alt: 'Client Logo 1'
},
{
  src: "/assets/images/image-1786011780942.png",
  alt: 'Client Logo 2'
},
{
  src: "/assets/images/image-1786011787384.png",
  alt: 'Client Logo 3'
},
{
  src: "/assets/images/image-1786011815843.png",
  alt: 'Client Logo 4'
},
{
  src: "/assets/images/image-1786011831776.png",
  alt: 'Client Logo 5'
}];


export default function ClientsSection() {
  return (
    <section
      className="py-12 overflow-hidden"
      style={{ backgroundColor: '#F5F7FA', fontFamily: 'Ubuntu, sans-serif' }}>
      {/* Heading */}
      <div className="text-center mb-8 px-4">
        <p
          className="text-sm font-semibold uppercase tracking-widest mb-2"
          style={{ color: '#00AAE2' }}>
          Our Clients
        </p>
        <h2
          className="text-2xl md:text-3xl font-bold"
          style={{ color: '#062543' }}>
          40+ Partners Have Put Their Trust In Us
        </h2>
      </div>
      {/* Marquee wrapper */}
      <div className="relative w-full">
        {/* Left fade */}
        <div
          className="absolute left-0 top-0 h-full w-16 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to right, #F5F7FA, transparent)'
          }} />
        
        {/* Right fade */}
        <div
          className="absolute right-0 top-0 h-full w-16 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to left, #F5F7FA, transparent)'
          }} />

        {/* Scrolling track */}
        <div className="flex animate-marquee hover:[animation-play-state:paused] w-max">
          {/* First set */}
          {clientLogos?.map((logo, i) =>
          <div
            key={`a-${i}`}
            className="flex-shrink-0 flex items-center justify-center w-[25vw] sm:w-[160px] px-2 mx-0 sm:mx-6 sm:px-4 h-[60px] sm:h-[80px]">
              <img
              src={logo?.src}
              alt={logo?.alt}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                display: 'block',
                filter: 'grayscale(20%)',
                opacity: 0.85
              }} />
            </div>
          )}
          {/* Duplicate set for seamless loop */}
          {clientLogos?.map((logo, i) =>
          <div
            key={`b-${i}`}
            className="flex-shrink-0 flex items-center justify-center w-[25vw] sm:w-[160px] px-2 mx-0 sm:mx-6 sm:px-4 h-[60px] sm:h-[80px]">
              <img
              src={logo?.src}
              alt={logo?.alt}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                display: 'block',
                filter: 'grayscale(20%)',
                opacity: 0.85
              }} />
            </div>
          )}
        </div>
      </div>
    </section>);


}